import api from './api'
import TokenService from './tokenService'
import { BASE } from './config'

class AuthService {
  login({ email, password }) {
    return api
      .post(`${BASE}/auth/sign_in/`, {
        email,
        password,
      })
      .then((response) => {
        if (response.data.access) {
          TokenService.setUser(response.data)
        }

        return response.data
      })
  }

  async logout() {
    try {
      const response = await api.post(`${BASE}/auth/logout/`, {
        refresh: TokenService.getLocalRefreshToken(),
        registration_id: sessionStorage.getItem('registration_id'),
      })

      TokenService.removeUser()

      sessionStorage.removeItem('registration_id')

      return response
    } catch (e) {
      console.error(e)
    }
  }

  register({ role, email, password }) {
    return api.post(`${BASE}/auth/sign_up/`, {
      role,
      email,
      password,
    })
  }

  resetPassword(email) {
    return api.post(`${BASE}/auth/reset_password/`, {
      email,
    })
  }

  confirmNewPassword({ token, password, password_confirm }) {
    return api.post(`${BASE}/auth/reset_password/confirm/`, {
      token,
      password,
      password_confirm,
    })
  }

  completeInvitation({ token, password, password_confirm }) {
    return api.post(`${BASE}/auth/complete_invitation/`, {
      token,
      password,
      password_confirm,
    })
  }
}

export default new AuthService()
